import React from "react";
import { footerConfig } from "../../config/footerConfig";
import "./Footer.scss";

const Footer: React.FunctionComponent = () => {
  const { newsletterHref, socialLinks, legalLinks, copyright, sirius } = footerConfig;

  return (
    <footer className="footer theme-dark" role="contentinfo" aria-label="Site footer">
      <div className="footer-inner">

        {/* Top row: left column (newsletter + social) | right column (legal links) */}
        <div className="footer-row">

          <div className="footer-column">
            <a
              className="footer-newsletter-cta"
              href={newsletterHref}
              aria-label="Sign up for our newsletter"
            >
              Sign Up For Our Newsletter
            </a>
            <div className="footer-social-links">
              {socialLinks.map(function(item) {
                return (
                  <a
                    key={item.label}
                    href={item.href}
                    title={item.label}
                    aria-label={item.label}
                  >
                    <img src={item.icon} alt="" role="presentation" />
                  </a>
                );
              })}
            </div>
          </div>

          <div className="footer-links stack-md">
            {legalLinks.map(function(item) {
              return (
                <div
                  key={item.href}
                  className={`footer-links-link${item.isPrivacy ? " footer-links-link-icon" : ""}`}
                >
                  <a href={item.href} lang={item.lang}>
                    {item.text}
                  </a>
                </div>
              );
            })}
          </div>

        </div>

        {/* Bottom row: copyright text + SiriusXM */}
        <div className="footer-copyright">
          <div>
            <p className="small sans-serif">&copy;{new Date().getFullYear()} {copyright.name}</p>
            <p className="small sans-serif">{copyright.address}</p>
          </div>
          <a
            href={sirius.href}
            className="footer-sponsor"
            aria-label={sirius.ariaLabel}
          >
            <span>{sirius.label}</span>
            <img src={sirius.logoSrc} alt={sirius.logoAlt} />
          </a>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
